import styled from 'styled-components';
import { ButtonIconWrapper } from '../../components/Buttons/style';
import { Title } from '../../components/titles';
import { FontSize16, FontSize14 } from '../../components/fonts';
import { TextBlock } from '../../components/text';

export const ButtonIconWrapperNoMargin = styled(ButtonIconWrapper)`
    margin: 0;
`;

export const SupplyTitle = styled(Title)`
    ${FontSize16};
    margin-top: 60px;
    margin-bottom: 20px;
`;

export const SupplyTitleGas = styled(Title)`
    ${FontSize16};
    margin-top: 40px;
    margin-bottom: 20px;
`;

export const GasTypeTitle = styled(Title)`
    ${FontSize16};
    margin-bottom: 30px;
    margin-top: 20px;
`;

export const GasTypeCardsContainer = styled.section`
    width: 100%; 
    display: flex; 
    flex-wrap: nowrap;
    align-items: center;
    overflow-x: hidden;
    overflow-y: hidden;
    ${props => props.theme.mediaQueries.phone} {
        overflow-x: scroll;
    }
    padding-bottom: 30px;
`;

export const AccordionContainer = styled.div`
    margin-top: 60px;
    width: 100%;
`;

export const BooleanInputWrapper = styled.div`
    width: 100%;
`;

export const OptionalFieldsTitle = styled(Title)`
    ${FontSize16};
    width: 100%;
    margin-bottom: 10px;
    margin-top: 20px;
`;

export const PopupTextStyle = styled(TextBlock)`
    /* font-size: 12px; */
`;